import React from "react";
import CustomText from "../CustomText";
import { stageType } from "../../types/type";

function MatchTitle() {
  return (
    <div className="matchTitleContainer" style={{ display: "none" }}>
      <div className="matchTitle">
        <CustomText weight="700" size="medium" className="textWhite">
          AJIO LEGENDS LEAGUE
        </CustomText>
      </div>
    </div>
  );
}

export default MatchTitle;
